import { render, staticRenderFns } from "./OurStaffEditPage.vue?vue&type=template&id=26fa2bc2&"
import script from "./OurStaffEditPage.vue?vue&type=script&lang=ts&"
export * from "./OurStaffEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports